import { DateUtils } from '@vectord/utils';

function isCompletedClass(classStartTime) {
  const minDifference = DateUtils.getMinutesDifference(
    classStartTime,
    new Date()
  );

  return minDifference < -180;
}

export default isCompletedClass;
